import { Button } from '@accure/ui';
import { Check } from 'lucide-react';

export type MarkAsDoneButtonProps = {
  onClick: () => Promise<void>;
  loading?: boolean;
};

export function MarkAsDoneButton({ onClick, loading }: MarkAsDoneButtonProps) {
  return (
    <Button
      className="py-2 hover:bg-primary-100"
      variant="primaryOutline"
      onClick={onClick}
      disabled={loading}
      data-testid="mark-as-done-button"
    >
      <Check />
      Mark this task as done
    </Button>
  );
}
